var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.isOpened
          ? _c(
              "div",
              { ref: "drawer", staticClass: "drawer-panel" },
              [
                _c(
                  "drawer-inner",
                  { attrs: { title: _vm.title }, on: { close: _vm.close } },
                  [_vm._t("default")],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "fade-slow" } }, [
        _vm.isOpened
          ? _c("div", {
              staticClass: "drawer-panel__overlay",
              on: { click: _vm.close }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }